import { serialize } from '@/@core/libs/serialize/util'
import Http from '@/services/http'

// LIST ALL Target Style
export const styleList = (params = '') => Http.get(`/marketing-content-styles${serialize(params)}`)
export const styleCreate = (params = '') => Http.post('/marketing-content-styles', params)
export const styleByID = (params = '') => Http.get(`/marketing-content-styles/${params}`)
export const styleUpdate = (params = '') => Http.put(`/marketing-content-styles/${params.id}`, params)
export const styleDestroy = (params = '') => Http.delete(`/marketing-content-styles/${params.id}`)
